import { previewFileUrl } from '../fileBrowser/fileBrowserApi';

export const PDF_VIEWER_PATH = '/files/pdf-viewer';

export function pdfPreviewSrc(mountId: string, relativePath: string): string {
  return previewFileUrl(mountId, relativePath);
}

export function buildPdfViewerSearch(mountId: string, relativePath: string): string {
  const params = new URLSearchParams();
  params.set('mountId', mountId);
  params.set('path', relativePath);
  return params.toString();
}

export function pdfViewerHref(mountId: string, relativePath: string): string {
  return `${PDF_VIEWER_PATH}?${buildPdfViewerSearch(mountId, relativePath)}`;
}
